
import { TileSlider } from '../../__utils/sliders';
import MicroModal from 'micromodal';

// GLOBAL APP CONTROLLER
const controller = {
    init() {},
    loaded() {
        TileSlider.init();
        MicroModal.init();
    },
    resized() {},
    scrolled() {},
    keyDown(e) {},
    scrolled() {},
    keyDown(e) {},
    mouseUp(e) {},
};
export default controller;
